webpackJsonp([28],{

/***/ 1148:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CarouselModel = function () {
    function CarouselModel(_ref) {
        var count = _ref.count,
            goToStepCallback = _ref.goToStepCallback,
            _ref$startIndex = _ref.startIndex,
            startIndex = _ref$startIndex === undefined ? 1 : _ref$startIndex;

        _classCallCheck(this, CarouselModel);

        this.count = count;
        this.index = startIndex;
        this.goToStepCallback = goToStepCallback;
        this.interval = null;
        this.delayCounter = 1;
    }

    _createClass(CarouselModel, [{
        key: 'start',
        value: function start() {
            var _this = this;

            this.goToStep(this.index);
            this.interval = window.setInterval(function () {
                var shouldAttemptTransition = _this.delayCounter % 5 === 0;
                var canTransition = document.readyState === 'complete';
                if (shouldAttemptTransition) {
                    if (canTransition) {
                        _this.next();
                        _this.delayCounter = 1;
                    }
                } else {
                    _this.delayCounter += 1;
                }
            }, 1000);
        }
    }, {
        key: 'stop',
        value: function stop() {
            window.clearInterval(this.interval);
        }
    }, {
        key: 'next',
        value: function next() {
            this.goToStep(this.index + 1);
        }
    }, {
        key: 'goToStep',
        value: function goToStep(stepIndex) {
            this.index = Math.abs(stepIndex) % this.count || this.count;

            this.goToStepCallback(this.index);
        }
    }]);

    return CarouselModel;
}();

exports.default = CarouselModel;

/***/ }),

/***/ 1162:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(5);

var _carouselModel = __webpack_require__(1148);

var _carouselModel2 = _interopRequireDefault(_carouselModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATTRIBUTE_STEP = 'data-carousel-step';
var ATTRIBUTE_ACTIVE = 'data-carousel-active';
var CONTENT_ATTRIBUTE = 'data-carousel-content';

var heroCarousel = function heroCarousel() {
    this.attributes({
        stepElement: '[data-carousel-steps]',
        carouselElement: '[data-carousel-element]',
        attributeStep: '[data-carousel-step]',
        attributeActive: '[data-carousel-active]',
        contentAttribute: '[data-carousel-content]'
    });

    this.after('initialize', function () {
        this.model = new _carouselModel2.default({
            count: this.count(),
            goToStepCallback: this.goToStep.bind(this)
        });

        this.on('click', {
            attributeStep: this.captureStepClick
        });

        this.model.start();
    });

    this.count = function () {
        return this.select('stepElement').find(this.attr.attributeStep).length;
    };

    this.goToStep = function (stepIndex) {
        Array.from(this.select('stepElement').find(this.attr.attributeActive)).forEach(function (step) {
            return step.removeAttribute(ATTRIBUTE_ACTIVE);
        });

        Array.from(this.select('contentAttribute')).forEach(function (step) {
            return step.removeAttribute(ATTRIBUTE_ACTIVE);
        });

        this.node.setAttribute(ATTRIBUTE_STEP, stepIndex);
        if (this.currentStepElement(stepIndex)) {
            this.currentStepElement(stepIndex).setAttribute(ATTRIBUTE_ACTIVE, true);
        }

        if (this.currentContentElement(stepIndex)) {
            this.currentContentElement(stepIndex).setAttribute(ATTRIBUTE_ACTIVE, true);
        }
    };

    this.currentStepElement = function (index) {
        return this.select('stepElement')[0].querySelector('[' + ATTRIBUTE_STEP + '="' + index + '"]');
    };

    this.currentContentElement = function (index) {
        return this.node.querySelector('[' + CONTENT_ATTRIBUTE + '][' + ATTRIBUTE_STEP + '="' + index + '"]');
    };

    this.captureStepClick = function (event) {
        var stepElement = event.target;
        var stepElementIndex = Number(stepElement.getAttribute(ATTRIBUTE_STEP));

        if (stepElementIndex) {
            this.model.stop();
            this.model.goToStep(stepElementIndex);
        }
    };
};

exports.default = (0, _flightjs.component)(heroCarousel);

/***/ }),

/***/ 1167:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScrollToElement = function () {
    function ScrollToElement(element, offsetTop) {
        _classCallCheck(this, ScrollToElement);

        this.element = element;
        this.offsetTop = offsetTop || 0;
    }

    _createClass(ScrollToElement, [{
        key: 'handleClick',
        value: function handleClick() {
            var _this = this;

            if (!this.element) return;

            this.element.addEventListener('click', function (e) {
                e.preventDefault();

                scrollToElement(getElementToScrollTo(e.currentTarget), _this.offsetTop);
            });
        }
    }]);

    return ScrollToElement;
}();

exports.default = ScrollToElement;


function getElementToScrollTo(element) {
    var toElementId = element.getAttribute('data-scrollto');

    if (toElementId.indexOf('#') === 0) {
        toElementId = toElementId.split('#')[1];
    }

    return document.getElementById(toElementId);
}

function getTopPositionFromViewport(element) {
    return element.getBoundingClientRect().top + window.pageYOffset;
}

function scrollToElement(toElement, offsetTop) {
    if (toElement) {
        (0, _jquery2.default)('html, body').animate({
            scrollTop: getTopPositionFromViewport(toElement) - offsetTop
        }, 500);
    }
}

/***/ }),

/***/ 1196:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VelocityScrollable = function () {
    function VelocityScrollable(raf, movementCallback) {
        _classCallCheck(this, VelocityScrollable);

        this.raf = raf;
        this.velocity = 0;
        this.threshold = 300;
        this.maxVelocity = 10;
        this.isActive = false;
        this.movementCallback = movementCallback;
    }

    _createClass(VelocityScrollable, [{
        key: "stop",
        value: function stop() {
            this.isActive = false;
        }
    }, {
        key: "start",
        value: function start() {
            this.isActive = true;
            this.waitForMovement();
        }
    }, {
        key: "waitForMovement",
        value: function waitForMovement() {
            var _this = this;

            this.raf.call(null, function () {
                _this.move(_this.velocity);
                _this.waitForMovement();
            });
        }
    }, {
        key: "registerMovement",
        value: function registerMovement(left, right) {
            if (this.isActive) {
                this.velocity = this.calculateVelocity(left, right);
            } else {
                this.velocity = 0;
            }
        }
    }, {
        key: "calculateVelocity",
        value: function calculateVelocity(left, right) {
            if (left < this.threshold) {
                return (this.threshold - left) / this.threshold * -this.maxVelocity;
            } else if (right < this.threshold) {
                return (this.threshold - right) / this.threshold * this.maxVelocity;
            } else {
                return 0;
            }
        }
    }, {
        key: "move",
        value: function move(offset) {
            this.movementCallback(offset);
        }
    }]);

    return VelocityScrollable;
}();

exports.default = VelocityScrollable;

/***/ }),

/***/ 1199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(5);

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

var _velocityScrollableModel = __webpack_require__(1196);

var _velocityScrollableModel2 = _interopRequireDefault(_velocityScrollableModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollable = function scrollable() {
    this.attributes({
        inner: '[data-scrollable-inner]',
        startingBreakpoint: false
    });

    this.after('initialize', function () {
        this.removeExtraSpacing();
        this.centerAlign();

        this.model = new _velocityScrollableModel2.default(window.requestAnimationFrame.bind(window), this.move.bind(this));

        if (this.attr.startingBreakpoint !== 'small') {
            this.model.start();
        }

        this.on(document, 'uiBreakpointChanged', this.toggleModel);
        this.on(this.node, 'mousemove', this.detectVelocity);
        this.on(this.node, 'mouseout', this.stopVelocity);
    });

    this.move = function (offset) {
        this.select('inner')[0].scrollLeft += offset;
    };

    this.stopVelocity = function () {
        this.model.velocity = 0;
    };

    this.detectVelocity = function (e) {
        var left = e.clientX;
        var right = document.documentElement.clientWidth - e.clientX;

        this.model.registerMovement(left, right);
    };

    /**
     * Adjust the spacing of a horizontally scrollable element to remove extra spacing
     * caused by browsers.
     */
    this.removeExtraSpacing = function () {
        var defaultHeightDifference = -20;

        var inner = this.select('inner')[0];
        var heightDifference = inner.clientHeight - this.node.clientHeight;

        if (heightDifference === 0) {
            inner.style.marginTop = defaultHeightDifference + 'px';
            inner.style.bottom = defaultHeightDifference + 'px';
            inner.style.paddingBottom = -1 * defaultHeightDifference + 'px';
        } else {
            inner.style.marginTop = heightDifference + 'px';
            inner.style.bottom = heightDifference + 'px';
        }
    };

    this.centerAlign = function () {
        var _this = this;

        return new Promise(function (resolve) {
            _this.select('inner').each(function (idx, el) {
                el.scrollLeft = ((0, _jquery2.default)(el).data('size') - window.innerWidth) / 2;
            });

            resolve(_this.select('inner'));
        });
    };

    this.toggleModel = function (e, breakpoint) {
        if (breakpoint === 'small') {
            this.model.stop();
        } else {
            this.model.start();
        }
    };
};

exports.default = (0, _flightjs.component)(scrollable);

/***/ }),

/***/ 1565:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(872);


/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Provides this syntax:
// $(img).loadImage(someUrl);

_jquery2.default.fn.loadImage = function (newSrc) {
    var img = this,
        promise = _jquery2.default.Deferred();

    var successCallback = function successCallback() {
        img.unbind('load', successCallback);
        img.unbind('error', failureCallback);
        promise.resolve(img);
    };

    var failureCallback = function failureCallback() {
        img.unbind('load', successCallback);
        img.unbind('error', failureCallback);
        promise.reject(img);
    };

    img.bind('error', failureCallback);
    img.bind('load', successCallback);

    img.attr('src', newSrc);

    // If the url is cached and loaded,
    // call the callback by hand.
    //
    if (img[0]) {
        if (img[0].complete || img[0].readyState) {
            successCallback();
        }
    }

    // Return the promise
    //
    return promise;
};

// Provides two additional syntax's:
//
//   $.loadImage(imgEl, someUrl);
//   $.loadImage(someUrl);

_jquery2.default.loadImage = function (img, newSrc) {
    if (_jquery2.default.type(newSrc) == 'undefined') {
        var newSrc = img,
            img = (0, _jquery2.default)('<img />');
    } else {
        var img = (0, _jquery2.default)(img);
    }
    return img.loadImage(newSrc);
};

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(5);

__webpack_require__(167);

var entryThumbnail = function entryThumbnail() {
    this.attributes({
        image: '[data-entry-thumbnail-image]'
    });

    this.after('initialize', function () {
        var $image = this.select('image');

        $image.loadImage($image.attr('src')).done(function () {
            this.toggleLoaded();
        }.bind(this));
    });

    this.toggleLoaded = function () {
        this.$node.attr('data-image-loaded', true);
    };
};

exports.default = (0, _flightjs.component)(entryThumbnail);

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _scrollToElement = __webpack_require__(1167);

var _scrollToElement2 = _interopRequireDefault(_scrollToElement);

var _entryThumbnail = __webpack_require__(174);

var _entryThumbnail2 = _interopRequireDefault(_entryThumbnail);

var _heroCarousel = __webpack_require__(1162);

var _heroCarousel2 = _interopRequireDefault(_heroCarousel);

var _scrollable = __webpack_require__(1199);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _breakpointBroadcaster = __webpack_require__(991);

var _breakpointBroadcaster2 = _interopRequireDefault(_breakpointBroadcaster);

var _breakpoints = __webpack_require__(994);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.addEventListener('DOMContentLoaded', function () {
    _breakpointBroadcaster2.default.attachTo(document);
    var scrollToElements = document.querySelectorAll('[data-scrollto]');
    Array.from(scrollToElements).forEach(function (element) {
        return new _scrollToElement2.default(element).handleClick();
    });

    _heroCarousel2.default.attachTo('[data-carousel]');
    _entryThumbnail2.default.attachTo('[data-entry]');
    _scrollable2.default.attachTo('[data-scrollable]', {
        startingBreakpoint: (0, _breakpoints.currentBreakpoint)()
    });

    $('[data-async-src]').each(function (e, i) {
        $(this).attr('src', $(this).data('async-src'));
    });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 991:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(5);

var breakpointBroadcaster = function breakpointBroadcaster() {
    this.after('initialize', function () {
        this.on(document, 'media-query:match', this.broadcastChange);
    });

    this.broadcastChange = function (e, breakpoint) {
        this.$node.trigger('uiBreakpointChanged', breakpoint);
    };
};

exports.default = (0, _flightjs.component)(breakpointBroadcaster);

/***/ }),

/***/ 994:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.currentBreakpoint = currentBreakpoint;
function currentBreakpoint() {
    if ($(document).data('mediaQueryLabel') !== undefined) {
        return $(document).data('mediaQueryLabel').get();
    } else {
        return null;
    }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ })

},[1565]);


// WEBPACK FOOTER //
// contest/marketing-summary-ee85019b47cdf230ca03.js